/* eslint-disable import/prefer-default-export */
export const DUPLICATE_MESSAGE = '이미 존재하는 파일명입니다.';
export const MSG_UPLOAD_UNAUTHORIZED_FILE = '업로드할 수 없는 파일형식입니다.';
export const MSG_UPLOAD_IMAGE_ONLY = '이미지파일만 업로드 가능합니다.(jpg/gif/jpeg/png)';



// WEBPACK FOOTER //
// ./src/constants/file.js